import { SvgProps } from "@/utils/types";

export const Tent = ({
  className,
  primaryColor,
  secondaryColor,
  tertiaryColor,
  outlineColor,
}: SvgProps) => {
  return (
    <svg
      width="67"
      height="95"
      viewBox="0 0 67 95"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M63.649 37.9209H3.35583V45.7139H63.649V37.9209Z"
        fill={primaryColor || "#D5E065"}
      />
      <path
        d="M60.942 73.2244H6.32385V91.6442H60.942V73.2244Z"
        fill={tertiaryColor || "#CAC0FC"}
      />
      <path
        d="M8.00183 34.222H59.1672L33.9835 17.7784L8.00183 34.222ZM21.9397 31.9774L16.7643 32.3502L30.8961 22.5736L21.9397 31.9699V31.9774Z"
        fill={primaryColor || "#D5E065"}
      />
      <path
        d="M60.942 49.1891H53.5815V69.8685H60.942V49.1891Z"
        fill={secondaryColor || "#F96E09"}
      />
      <path
        d="M13.2145 49.1891H6.32385V69.8685H13.2145V49.1891Z"
        fill={secondaryColor || "#F96E09"}
      />
      <path
        d="M50.2257 49.0698H16.5779V49.1966H50.2257V49.0698Z"
        fill={outlineColor || "#540389"}
      />
      <path
        d="M53.5815 49.1891H60.942V69.8686H62.4856V73.2244H60.942V91.6442H6.32385V73.2244H4.72797V69.8686H6.32385V49.1891H13.222V49.0698H2.96802V95H64.2978V49.0698H53.5815V49.1891Z"
        fill={outlineColor || "#540389"}
      />
      <path
        d="M7.46484 34.5651H59.6817L59.1671 34.222H8.00178L7.46484 34.5651Z"
        fill={outlineColor || "#540389"}
      />
      <path
        d="M65.5134 34.3563L65.6029 34.416C66.3188 34.8784 66.632 35.7434 66.3859 36.5563C66.1398 37.3691 65.409 37.921 64.5588 37.921H63.649V45.714H3.35584V37.921H2.52061C1.65555 37.921 0.917262 37.3617 0.671167 36.5339C0.43253 35.7061 0.760656 34.8336 1.49148 34.3713L1.53623 34.3414C0.648795 34.6323 0 35.46 0 36.4444V49.0624H2.96805V45.8333H64.2978V49.0624H66.9974V36.4444C66.9974 35.475 66.371 34.6621 65.5059 34.3563H65.5134Z"
        fill={outlineColor || "#540389"}
      />
      <path
        d="M2.96802 45.8333V49.0698H13.222V46.6312H16.5778V49.0698H50.2257V47.5112H53.5815V49.0698H64.2978V45.8333H2.96802Z"
        fill={outlineColor || "#540389"}
      />
      <path
        d="M63.649 37.5779H3.35583V37.9135H63.649V37.5779Z"
        fill={outlineColor || "#540389"}
      />
      <path
        d="M8.00183 34.2221L33.9835 17.7785L59.1672 34.2221H64.7751C65.0361 34.2221 65.2748 34.2743 65.506 34.3563L35.5346 14.7881V15.8694H32.1788V14.9447L1.53625 34.3489C1.75252 34.2743 1.9837 34.2296 2.22234 34.2296H8.00183V34.2221Z"
        fill={outlineColor || "#540389"}
      />
      <path
        d="M0.671203 36.5338C0.90984 37.3616 1.65558 37.9209 2.52064 37.9209H3.35587V37.5853H63.6491V37.9209H64.5589C65.409 37.9209 66.1398 37.3765 66.3859 36.5562C66.632 35.7434 66.3114 34.8783 65.6029 34.4159L65.5134 34.3563C65.2822 34.2742 65.0361 34.222 64.7826 34.222H59.1746L59.6892 34.5576H7.46491L8.00184 34.222H2.22234C1.98371 34.222 1.75253 34.2668 1.53626 34.3414L1.49152 34.3712C0.760692 34.8336 0.432566 35.6986 0.671203 36.5338Z"
        fill={outlineColor || "#540389"}
      />
      <path
        d="M53.5815 71.6732H50.2257V69.8685H41.1052C41.2246 70.4055 41.2917 70.9722 41.2917 71.5464H25.9741C25.9741 70.9722 26.0413 70.4129 26.1606 69.8685H16.5703V72.0834H13.2145V69.8685H6.32385V73.2244H60.942V69.8685H53.5815V71.6732Z"
        fill={outlineColor || "#540389"}
      />
      <path
        d="M6.32391 69.8685H4.72803V73.2244H6.32391V69.8685Z"
        fill={outlineColor || "#540389"}
      />
      <path
        d="M62.4857 69.8685H60.942V73.2244H62.4857V69.8685Z"
        fill={outlineColor || "#540389"}
      />
      <path
        d="M53.5815 49.1891H50.2257V69.8685H53.5815V49.1891Z"
        fill={outlineColor || "#540389"}
      />
      <path
        d="M53.5815 49.0698H50.2257V49.1966H53.5815V49.0698Z"
        fill={outlineColor || "#540389"}
      />
      <path
        d="M53.5815 47.5112H50.2257V49.0624H53.5815V47.5112Z"
        fill={outlineColor || "#540389"}
      />
      <path
        d="M53.5815 69.8685H50.2257V71.6732H53.5815V69.8685Z"
        fill={outlineColor || "#540389"}
      />
      <path
        d="M16.5779 49.1891H13.222V69.8685H16.5779V49.1891Z"
        fill={outlineColor || "#540389"}
      />
      <path
        d="M16.5779 49.0698H13.222V49.1966H16.5779V49.0698Z"
        fill={outlineColor || "#540389"}
      />
      <path
        d="M16.5779 46.6312H13.222V49.0623H16.5779V46.6312Z"
        fill={outlineColor || "#540389"}
      />
      <path
        d="M16.5779 69.8685H13.222V72.0834H16.5779V69.8685Z"
        fill={outlineColor || "#540389"}
      />
      <path
        d="M36.4021 61.048C37.931 59.519 37.931 57.0401 36.4021 55.5111C34.8731 53.9822 32.3942 53.9822 30.8652 55.5111C29.3363 57.0401 29.3363 59.519 30.8652 61.048C32.3942 62.5769 34.8731 62.5769 36.4021 61.048Z"
        fill={outlineColor || "#540389"}
      />
      <path
        d="M33.6404 63.8802C29.9863 63.8802 26.9287 66.4456 26.1681 69.8686H41.1128C40.3446 66.4456 37.2946 63.8802 33.6479 63.8802H33.6404Z"
        fill={outlineColor || "#540389"}
      />
      <path
        d="M25.9741 71.5464H41.2916C41.2916 70.9722 41.2245 70.4129 41.1052 69.8685H26.1606C26.0412 70.4055 25.9741 70.9722 25.9741 71.5464Z"
        fill={outlineColor || "#540389"}
      />
      <path
        d="M32.9692 14.4525C33.6031 14.0498 34.4159 14.0572 35.0498 14.4674L35.542 14.7881V0H32.1862V0.596593H34.9827V7.77808H32.1862V14.9521L32.9692 14.4599V14.4525Z"
        fill={outlineColor || "#540389"}
      />
      <path
        d="M35.542 15.8694V14.788L35.0498 14.4674C34.4234 14.0572 33.6031 14.0498 32.9692 14.4525L32.1862 14.9446V15.8694H35.542Z"
        fill={outlineColor || "#540389"}
      />
      <path
        d="M22.76 0.701018V7.66624C25.8996 9.46348 29.0466 6.08527 32.1862 7.88251V0.484753C29.0466 -1.16334 25.8996 2.34911 22.76 0.701018Z"
        fill={outlineColor || "#540389"}
      />
      <path
        d="M34.9827 0.484753C34.0505 -1.16334 33.1183 2.34911 32.1862 0.701018V7.66624C33.1183 9.46348 34.0505 6.08527 34.9827 7.88251V0.484753Z"
        fill={outlineColor || "#540389"}
      />
      <path
        d="M21.9323 31.9849L30.8886 22.5811L16.7568 32.3577L21.9323 31.9849Z"
        fill={outlineColor || "#540389"}
      />
    </svg>
  );
};
